import { app, isFirebaseConfigured, getAuthInstance } from "@/lib/firebase";
import { buildAppsationsFunctionUrl } from "@/lib/appsationsSdkEndpoints";

async function getIdTokenIfAvailable(): Promise<string | undefined> {
  if (!app || !isFirebaseConfigured) return undefined;
  try {
    const auth = await getAuthInstance();
    const user = auth?.currentUser;
    if (!user) return undefined;
    return await user.getIdToken();
  } catch {
    return undefined;
  }
}

export async function updateSharedDashboardMeta(
  metaPatch: Record<string, unknown>,
  options?: { dashboardId?: string },
): Promise<boolean> {
  const url = buildAppsationsFunctionUrl("updateSharedDashboardMeta");
  try {
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
    };
    const idToken = await getIdTokenIfAvailable();
    if (idToken) headers["Authorization"] = `Bearer ${idToken}`;

    const body = JSON.stringify({
      dashboardId: options?.dashboardId ?? "shared-dashboard",
      metaPatch,
    });
    const res = await fetch(url, {
      method: "POST",
      headers,
      credentials: "same-origin",
    });
    if (!res.ok) return false;
    return true;
  } catch (err) {
    return false;
  }
}

export default updateSharedDashboardMeta;
